jQuery(function ($) {
  'use strict';

  /****======  Sticky Header ======*******/
  var scrollPosition = window.scrollY;
  if (scrollPosition >= 400) {
    $(".sticy-header").addClass("animated fadeInDown fixed");
  }
  var header = $(".sticy-header");
  $(window).on("scroll", function () {
    if ($(this).scrollTop() < 400) {
      header.removeClass("animated fadeInDown fixed");
    } else {
      header.addClass("animated fadeInDown fixed");
    }
  });


  /****======  newsLetter_popup ======*******/
  let selector = $(".modal-btn");
  selector.magnificPopup({
    type: "inline",
    closeBtnInside: true,
    autoFocusLast: true,
    focus: ".modal-title",
  });
  selector.click();

  /****======  Active class add Remove  ======*******/
  $(".menubar").on("click", function () {
    $(".mobile-menu__sidebar-menu ").addClass("active");
    $(".menu-closer").addClass("active");
  });

  $(".search-box.menu").on("click", function () {
    $(".search-box-popup").addClass("active");
  });
  $(".search-box-close").on("click", function () {
    $(".search-box-popup").removeClass("active");
  });

  $(".menu-closer").on("click", function () {
    $(".mobile-menu__sidebar-menu ").removeClass("active");
    $('.menu-closer').removeClass("active");
  });

  $(".mobile-menu__sidebar-menu .dropdown-list .menuarrow").on("click", function () {
    $(this).parent().parent().find(".dropdown").toggle(300);
    $(this).parent().parent().toggleClass("active");
  });

  $(".mobile-menu__sidebar-menu .dropdown .menuarrowtwo").on("click", function () {
    $(this).parent().parent().find(".subdropdown").toggle(300);
    $(this).parent().parent().toggleClass("active");
  });

  $(".cart-icon").on("click", function () {
    // $(".side-cart").addClass("active"); 
    $(".drawer").addClass("active"); 
    $(".side-cart-closer").addClass("active");
  });
  
  $(".cart-close").on("click", function () {
    // $(".side-cart").removeClass("active");
    $(".drawer").removeClass("active"); 
    $(".side-cart-closer").removeClass("active");
  });

  $(".cart-overlay").on("click", function () {
    // $(".side-cart").removeClass("active");
    $(".drawer").removeClass("active"); 
    $(".side-cart-closer").removeClass("active");
  });

  $(".menubar").on("click", function () {
    $(".sidebar-content").addClass("active");
    $(".sidebar-content-closer").addClass("active");
  });
  $(".close-side-widget").on("click", function () {
    $(".sidebar-content").removeClass("active");
  });

  $(".sidebar-content-closer").on("click", function () {
    $(".sidebar-content-closer").removeClass("active");
    $(".sidebar-content").removeClass("active");
  });

  $(".close-side-widget").on("click", function () {
    $(".sidebar-content-closer").removeClass("active");
  });

  $(".side-cart-closer").on("click", function () {
    // $(".side-cart").removeClass("active");
    $(".drawer").removeClass("active"); 
    $(".side-cart-closer").removeClass("active");
  });
 
  /*
  $(".slidebarfilter, .remove-sidebar").on("click", function () {
    $(".shop-grid-sidebar").toggleClass("active");
  });
  */

  $(".varients li a").on("click", function () {
    $(".varients li a").removeClass("active");
    $(this).addClass("active");
  });


  //=== CountDownTimer===  
  if ($(".time-countdown-two").length) {
    $(".time-countdown-two").each(function () {
      var Self = $(this);
      var countDate = Self.data('countdown-time'); // getting date

      Self.countdown(countDate, function (event) {
        $(this).html('<li> <div class="box"> <span class="days">' + event.strftime('%D') + '</span> <span class="timeRef">days</span> </div> </li> <li> <div class="box"> <span class="hours">' + event.strftime('%H') + '</span> <span class="timeRef clr-1">hours</span> </div> </li> <li> <div class="box"> <span class="minutes">' + event.strftime('%M') + '</span> <span class="timeRef clr-2">min</span> </div> </li> <li> <div class="box"> <span class="seconds">' + event.strftime('%S') + '</span> <span class="timeRef clr-3">sec</span> </div> </li>');
      });
    });
  };
 
  /****======  niceSelect  ======*******/
//   if ($("select").length) {
//     $("select:not(.not_nice_select)").niceSelect();
//   };


  /****======  Wow  ======*******/
  new WOW().init();


  /****====== Magnific popup_link  ======*******/
  if ($(".popup_link").length) {
    $(".popup_link").magnificPopup({
      type: "inline",
      midClick: true,
      mainClass: "mfp-fade"
    });    
  };

  /****====== Magnific popup video ======*******/
  if ($(".video-popup").length) {
    $(".video-popup").magnificPopup({
      type: 'iframe'
    });
  };


  /****====== MIXitup ======*******/
//   if ($(".products-grid").length) {
//     $('#grid').mixItUp();
//   };
 
 

  /****======  Jquery tabs  ======*******/
  $(".tabs").tabs({
    neighbors: {
      prev: $("button.prev"),
      next: $("button.next")
    }
  });


//   /****======  Increase and decrease number by click  ======*******/
//   if ($(".increaseQty").length) {
//     var minVal = 1,
//       maxVal = 20;
//     $(".increaseQty").on("click", function () {
//       var $parentElm = $(this).parents(".qtySelector");
//       $(this).addClass("clicked");
//       setTimeout(function () {
//         $(".clicked").removeClass("clicked");
//       }, 100);
//       var value = $parentElm.find(".qtyValue").val();
//       if (value < maxVal) {
//         value++;
//       }
//       $parentElm.find(".qtyValue").val(value);
//     });
//   };

//   if ($(".decreaseQty").length) {
//     $(".decreaseQty").on("click", function () {
//       var $parentElm = $(this).parents(".qtySelector");
//       $(this).addClass("clicked");
//       setTimeout(function () {
//         $(".clicked").removeClass("clicked");
//       }, 100);
//       var value = $parentElm.find(".qtyValue").val();
//       if (value > 1) {
//         value--;
//       }
//       $parentElm.find(".qtyValue").val(value);
//     });
//   };

 
  /****====== banner-one TweenMax Js  ======*******/
  if ($(".banner-one__single-slide").length) {
    $(".banner-one__single-slide").on("mousemove", function (e) {
      parallaxIt(e, ".banner-one__slideimg_two", -20);
      parallaxIt(e, ".banner-one__shape1", 10);
      parallaxIt(e, ".banner-one__shape2", 15);
      parallaxIt(e, ".banner-one__shape3", 25);
    });

    function parallaxIt(e, target, movement) {
      var $this = $(".banner-one__single-slide");
      var relX = e.pageX - $this.offset().left;
      var relY = e.pageY - $this.offset().top;

      TweenMax.to(target, 1, {
        x: (relX - $this.width() / 2) / $this.width() * movement,
        y: (relY - $this.height() / 2) / $this.height() * movement
      });
    }
  };

  /****====== upcoming-item TweenMax Js  ======*******/
  if ($(".upcoming-item").length) {
    $(".upcoming-item").on("mousemove", function (e) {
      parallaxIt(e, ".upcoming-item__signature", -50);
    });

    function parallaxIt(e, target, movement) {
      var $this = $(".upcoming-item");
      var relX = e.pageX - $this.offset().left;
      var relY = e.pageY - $this.offset().top;

      TweenMax.to(target, 1, {
        x: (relX - $this.width() / 2) / $this.width() * movement,
        y: (relY - $this.height() / 2) / $this.height() * movement
      });
    }
  };


  /* password show hide on form field  */
  if ($(".eye .icon-2").length) {
    $(".eye .icon-2").click(function () {
      var x = document.getElementById("password-field");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
      $(this).hide();
      $(".eye .icon-1").css("display", "block");
    });
  };

  if ($(".eye .icon-1").length) {
    $(".eye .icon-1").click(function () {
      var x = document.getElementById("password-field");
      if (x.type === "text") {
        x.type = "password";
      } else {
        x.type = "text";
      }
      $(this).hide();
      $(".eye .icon-2").css("display", "block");
    });
  };

  /*
  //  Price Filter 
  if ($("#price-range").length) {
    $("#price-range").slider({
      range: true,
      min: 0,
      max: 200000,
      values: [0, 200000],
      slide: function (event, ui) {
        $("#priceRange").val("$" + ui.values[0] + " - $" + ui.values[1]);
      }
    });
    $("#priceRange").val("$" + $("#price-range").slider("values", 0) + " - $" + $("#price-range").slider("values", 1));
  };
  */


  /****======  Bottom to Top Scroll Js  ======*******/
  var ScrollTop = $(".scrollToTop");
  $(window).on("scroll", function () {
    if ($(this).scrollTop() < 500) {
      ScrollTop.removeClass("active");
    } else {
      ScrollTop.addClass("active");
    }
  });
  $(".scrollToTop").on("click", function () {
    $("html, body").animate({
      scrollTop: 0
    }, 250);
    return false;
  });

  $(window).on("load", function () {
    /****======  Preloader Js  ======*******/
    $(".loader").delay(500).animate({
      "opacity": "0"
    }, 500, function () {
      $(".loader").css("display", "none");
    });
  });



  /**********************
  Update Home Js
  ***********************/
  /* Global Slider */

    var $elementCarousel = $(".globalSlider");
    $elementCarousel.each(function () {
      var appendArrow = $(this).siblings('.slick-arrow-container');
      $(this).slick({
        appendArrows: appendArrow,
        prevArrow: `<span class="slick-btn slick-prev"><i class="flaticon-back"></i></span>`,
        nextArrow: `<span class="slick-btn slick-next"><i class="flaticon-next"></i></span>`
      });
    });


  /* Tab Refresh */ 
  $(".nav-pills .nav-link").on("click", function (e) {
    $(".tab-pane .globalSlider").resize();
    $(".tab-pane .slick-slider").slick("refresh");
  }); 
 
  $('.nav-pills button[data-bs-toggle="pill"]').on('shown.bs.tab', function (e) {
    e.target
    e.relatedTarget
    $('.globalSlider').slick('setPosition');
  });
 
  if ($(".nav-pills .nav-link").length) {
    $(".nav-pills .nav-link").click(function () {
      $("#overlay").fadeIn().delay(100).fadeOut();
    });
  }; 

  /****====== Custom Accordian Js ======*******/
  $(".accordion .accordion-button").on("click", function (e) {
    $(".accordion .globalSlider").resize();
    $(".accordion .slick-slider").slick("refresh");
  });
  

  /****===== MagnificPopup Js ======*******/
  if ($(".popupVideo").length) {
    $('.popupVideo').magnificPopup({
      type: 'iframe'
    });
  };

    /**********************
   HomeSlider 2
   ***********************/
   $(".homeSlider22").slick({
    autoplay: false,
    arrows: true,
    prevArrow: "<span class='slick-btn slick-prev'></span>",
    nextArrow: "<span class='slick-btn slick-next'></span>",
    dots: false,
    slidesToShow: 1,
    infinite: true,
    dots: true,
    speed: 700,
    autoplaySpeed: 900
  });



}(jQuery));